export default __webpack_public_path__ + "static/media/arrow-rotate-right-solid-enable.4ad3ad12.svg";